export const limitCharacters = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const checkCharacterLimit = (text, maxLength) => {
  return {
    isOverLimit: text.length > maxLength,
    remaining: maxLength - text.length,
    limitedText: text.length > maxLength ? text.substring(0, maxLength) : text
  };
};